import React from 'react';
import styled from 'styled-components';
import ChevronDown from 'icons/src/ChevronDown';

const NavItemIcon = ({ children, className }) => (
  <span className={className}>
    {children || <ChevronDown />}
  </span>
);

export default styled(NavItemIcon)`
  padding-left: .25rem;
  svg {
    width: .75rem;
    vertical-align: middle;
  }
`;
